module.exports = __webpack_public_path__ + "media/images/silver-medal-241477cadb43213f985bbda4f46eb6fd.svg";